import { useCallback } from "react";
import CategoryBrowser from "@/components/feature/CategoryBrowser";
import { filterNewsList } from "@/utils/content";
import { newsCategories, newsSorts } from "@/mocks/categories";
import type { ContentItem } from "@/types/content";

const groups = [
  { key: "category", label: "资讯分类", options: newsCategories },
  { key: "sort", label: "排序方式", options: newsSorts.map((s) => s.label) },
];

const initialValues: Record<string, string> = {
  category: "全部",
  sort: newsSorts[0].label,
};

export default function NewsPage() {
  const filter = useCallback((values: Record<string, string>): ContentItem[] => {
    const sort = newsSorts.find((s) => s.label === values.sort)?.key ?? "time";
    return filterNewsList(values.category, sort);
  }, []);

  return (
    <CategoryBrowser
      heading="影视资讯"
      crumbLabel="影视资讯"
      description="影视工厂资讯频道为你汇总行业观察、技术动态、平台信息与热点评论，支持按分类与时间、热门度排序，帮助你快速掌握影视行业的最新动向。"
      groups={groups}
      initialValues={initialValues}
      filter={filter}
      emptyText="暂无相关资讯"
      cardLayout="wide"
      pageSize={6}
    />
  );
}